import Footermain from "./Footer_main";
import "./css-components/contact.css";
import contact from "./content/contact.png";


function Contact(){

    return(
        <>
        <section className="contact">
            <div className="container contact__container">
                <aside className="contact__aside">
                    <div className="aside__image">
                        <img src={contact} alt="" />
                    </div>
                    <h2>Contact Us</h2>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit.?</p>
                    <ul className="contact__details">
                        <li>
                        <i class="fa-solid fa-phone"></i>
                        <h5><a href="tel:7749807715">+91-7749807715</a></h5>
                        </li>
                        <li>
                        <i class="fa-solid fa-envelope"></i>
                        <h5><a href="/">techsagarsingh@gmail.com</a></h5>
                        </li>
                        <li>
                        <i class="fa-solid fa-location-dot"></i>
                        <div class="mapouter">
                            <div class="gmap_canvas">
                                <iframe title="myFrame" class="gmap_iframe" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?width=199&amp;height=147&amp;hl=en&amp;q=patel nagar&amp;t=&amp;z=20&amp;ie=UTF8&amp;iwloc=B&amp;output=embed">
                                </iframe>
                                <a href="https://mcpepro.com/">Minecraft Download</a>
                                </div>
                            </div>
                        </li>
                    </ul>
                </aside>

                <form  method="POST" className="contact__form" action="https://formspree.io/f/mdobbppr">
                        <div className="form__name">
                            <input type="text" name="First name" placeholder="First Name" required/>
                            <input type="text" name="Last name" placeholder="Last Name" required/>
                        </div>
                        <input type="email" name="Email Address" placeholder="Your Email Address" required />
                        <textarea name="Message" placeholder="Message" rows="7" required></textarea>
                        <button type="submit" className="btn btn-primary">Send Message</button>
                </form>
            </div>
        </section>
        <Footermain/>
     </>
    )
}
export default Contact;